import { ChangeDetectorRef, Component, HostListener, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { FindUserByNicknevResponseDto, FranchisePartnerSendRequestDto } from '../personal-site.interfaces';
import {
  MobilePackageDetails,
  MobilePackageDisplayType,
} from '../../../shared/components/large-mobile-package/large-mobile-package.interfaces';
import { PersonalSiteService } from '../personal-site.service';
import { IMobileServiceResolverData } from '../../mobile-services/mobile-services.interface';
import { MobileServicesService } from '../../mobile-services/mobile-services.service';
import { SelectedPhonePackageService } from '../../devices/selected-phone-package.service';
import { ScrollService } from '../../../shared/services/scroll-service/scroll.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactFormStatus } from '../../../global/global.enums';
import { ExposedEnvironmentVariable } from '../../../../environments/environment-variables';
import { EnvironmentVariablesService } from '../../../core/services/environment-variable-service/environment-variables.service';
import { GoogleAnalyticsService } from '../../../core/services/google-analytics-service/google-analytics.service';
import { FacebookPixelService } from '../../../core/services/facebook-pixel-service/facebook-pixel.service';
import {
  GreyRibbonWithShareButtonPositionEnum,
  IGreyRibbonWithShareButtonDescription,
} from '../../../shared/components/grey-ribbon-with-share-button/grey-ribbon-with-share-button.interfaces';
import { isPlatformBrowser } from '@angular/common';
import { SHARED_MOBILE_PACKAGES } from '../../../global/mobile-services.constants';

@Component({
  selector: 'ose-franchise-partner-personal-site',
  templateUrl: './franchise-partner-personal-site.component.html',
  styleUrls: ['./franchise-partner-personal-site.component.scss'],
})
export class FranchisePartnerPersonalSiteComponent implements OnInit {
  @Input() user!: FindUserByNicknevResponseDto;
  @Input() allServicesData!: IMobileServiceResolverData;

  editForm: FormGroup;
  formSubmitText: string = ContactFormStatus.SEND;
  recaptchaKey: string;

  profileImgSrc = '';

  packages: MobilePackageDetails[] = SHARED_MOBILE_PACKAGES;

  innerWidth: number;

  customRibbonDescription: IGreyRibbonWithShareButtonDescription = {
    description: 'Az árak 10 hónapos hűséggel értendők!',
    position: GreyRibbonWithShareButtonPositionEnum.BEFORE,
  };

  get f(): { [p: string]: AbstractControl } {
    return this.editForm.controls;
  }

  constructor(
    private personalSiteService: PersonalSiteService,
    @Inject(PLATFORM_ID) private platformId: object,
    private mobileServicesService: MobileServicesService,
    private selectedPhonePackageService: SelectedPhonePackageService,
    private scrollService: ScrollService,
    private cdr: ChangeDetectorRef,
    private environmentVariablesService: EnvironmentVariablesService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private facebookPixelService: FacebookPixelService,
    private fb: FormBuilder
  ) {
    this.editForm = this.fb.group({
      name: [null, Validators.required],
      city: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [null, Validators.required],
      comment: [null, Validators.required],
      captcha: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.recaptchaKey = this.environmentVariablesService.getVar(ExposedEnvironmentVariable.RECAPTCHA_KEY);

    this.user.telefonszam = this.user.telefonszam.startsWith('+') ? this.user.telefonszam : `+${this.user.telefonszam}`;

    this.profileImgSrc = this.personalSiteService.getImageSrc(this.user.nicknev);
    if (isPlatformBrowser(this.platformId)) {
      this.innerWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = (event.target as Window).innerWidth;
  }

  onSend(): void {
    if (this.editForm.valid) {
      const request: FranchisePartnerSendRequestDto = {
        ...this.editForm.value,
        nickname: this.user.nicknev,
      };
      this.personalSiteService.send(request).subscribe(() => {
        this.editForm.reset();
        this.formSubmitText = ContactFormStatus.SENT;
        this.googleAnalyticsService.eventEmitter({
          event_name: 'kattintas',
          event_category: 'franchise_partner_kattintas',
          event_label: 'gomb',
        });
        this.facebookPixelService.eventEmitter('track', 'Lead', { value: '5000.00', currency: 'HUF' });
      });
    }
  }

  isSent(): boolean {
    return this.formSubmitText === ContactFormStatus.SENT;
  }

  order(packageItem: MobilePackageDetails): void {
    this.mobileServicesService.order(packageItem);
  }

  onFailLoadImage(): void {
    this.profileImgSrc = 'assets/images/sarga_lanyka_uj.webp';
  }

  getUserCity(telepules: string): string {
    const splitArray = telepules.split(',');
    return splitArray.length > 2 && splitArray[1].toLowerCase().includes('kerület')
      ? `${splitArray[0]} ${splitArray[1]}`
      : splitArray[0];
  }

  getOrangeElementTopOffset(): string {
    const greyBackgroundContainer = document.getElementById('black-background-container');
    return `${greyBackgroundContainer.offsetTop + greyBackgroundContainer.offsetHeight + 20}px`;
  }

  generateNameFontSize(): string {
    if (this.innerWidth) {
      if (this.innerWidth > 1200) {
        return `${this.user.nev.length < 15 ? 59 : this.user.nev.length < 30 ? 48 : 44}px`;
      } else if (this.innerWidth > 768) {
        return `${this.user.nev.length < 15 ? 40 : this.user.nev.length < 30 ? 35 : 30}px`;
      }
      return `${this.user.nev.length < 15 ? 24 : this.user.nev.length < 30 ? 22 : 20}px`;
    }
    return '';
  }

  getCustomRibbonDescription(): IGreyRibbonWithShareButtonDescription {
    return this.innerWidth < 768 ? this.customRibbonDescription : null;
  }
}
